/* eslint-disable */
import React, { useRef } from 'react'
import * as THREE from 'three'

import 'react-three-fiber'

function Mound(props) {
    const mesh = useRef()
    const moundShape = new THREE.Shape()
    const radius = 8
    const extrudeSettings = {
        depth: 2,
        bevelEnabled: true,
        bevelSegments: 2,
        steps: 2,
        bevelSize: 1,
        bevelThickness: 1,
    }
    const rx = 0
    const ry = 0
    const rz = 0
    const s = 1
    const moundPosition = [0, 59, 0]

    // Set mound position
    if (props.position && props.position.length == 3) {
        moundPosition[0] = props.position[0]
        moundPosition[1] = props.position[1] + 59
        moundPosition[2] = props.position[2]
    }

    moundShape.moveTo(0, 0)
    moundShape.absarc(0, 0, radius, 0, 2 * Math.PI, false)
    const geometry = new THREE.ExtrudeGeometry(moundShape, extrudeSettings)

    return (
        <group>
            <mesh
                ref={mesh}
                rotation={[rx, ry, rz]}
                position={moundPosition}
                geometry={geometry}
                material={new THREE.MeshPhongMaterial({ color: 0xffffff })}
            />
        </group>
    )
}

export default Mound
